import { FormikProps } from "formik";
import { useContext, useMemo } from "react";
import {
  SubmitCreation,
  SubmitCreationBand,
} from "../../../../../generated/data-contracts";
import {
  AvisEditableList,
  editableTableActionWidth,
  IAvisEditableListFieldConfig,
  IRowState,
} from "../../../../shared/components/editableList";
import { AvisSection } from "../../../../shared/components/form";
import { AvisInputText } from "../../../../shared/components/inputs";
import { AvisContext } from "../../../../shared/context/AvisContext";

interface ICreationNewBandsProps {
  bag: FormikProps<SubmitCreation>;
  bagField: keyof SubmitCreation;
  disabled: boolean;
  textKey: string;
}
export function CreationNewBands(props: Readonly<ICreationNewBandsProps>) {
  const { bag, bagField, disabled, textKey } = props;
  const { res } = useContext(AvisContext);

  const fieldCollection: IAvisEditableListFieldConfig<
    IRowState<SubmitCreationBand>
  >[] = useMemo(
    () => [
      {
        name: "entertainerOrGroup",
        title: res("authors_Creation_label_EntertainerOrGroup"),
        required: true,
        width: 280 + (disabled ? editableTableActionWidth : 0),
        renderField: (field, prefix, i, val, onChange) => {
          return (
            <AvisInputText
              name={`${prefix}.${i}.${field.name}`}
              value={val[field.name]}
              maxLength={100}
              onChange={onChange}
              required={field.required}
              disabled={disabled}
              hideClear
            />
          );
        },
      },
    ],
    [disabled, res],
  );

  return (
    <AvisSection
      title={res("authors_Creation_Section_Bands_Title")}
      textToDisplayKey={textKey}
    >
      <AvisEditableList<SubmitCreation, SubmitCreationBand>
        bag={bag}
        bagField={bagField}
        initValue={{ entertainerOrGroup: "" }}
        fields={fieldCollection}
        disabled={disabled}
      />
    </AvisSection>
  );
}
